import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const SecurityDepositPolicy = ({
  containerStyle,
  iconColor = "#1a5c2a",
  textColor = "#1a5c2a",
  showIcon = true,
  compact = false,
}) => {
  const ShieldIcon = ({ size = 18, color = "#1a5c2a" }) => (
    <svg
      viewBox="0 0 512 512"
      width={size}
      height={size}
      fill="none"
      stroke={color}
      strokeWidth={32}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ flexShrink: 0 }}
    >
      <path d="M256,48S64,96,64,96v160c0,128,96,208,192,240,96-32,192-112,192-240V96S256,48,256,48Z" />
      <polyline points="368 192 256 304 208 256" />
    </svg>
  );

  const InfoIcon = ({ size = 14, color = "#1a5c2a" }) => (
    <svg
      viewBox="0 0 512 512"
      width={size}
      height={size}
      fill="none"
      stroke={color}
      strokeWidth={32}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ flexShrink: 0, marginTop: 1 }}
    >
      <path
        d="M256,80a176,176,0,1,0,176,176A176,176,0,0,0,256,80Z"
        strokeMiterlimit={10}
      />
      <polyline points="220 220 252 220 252 336" />
      <line x1="208" y1="340" x2="296" y2="340" />
      <path
        d="M256,160a16,16,0,1,0-16-16A16,16,0,0,0,256,160Z"
        fill={color}
        stroke="none"
      />
    </svg>
  );

  if (compact) {
    return (
      <Box
        sx={{
          backgroundColor: "#E8F5E9",
          borderRadius: "8px",
          padding: "10px",
          marginTop: "10px",
          ...containerStyle,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: "6px" }}>
          {showIcon && <ShieldIcon size={16} color={iconColor} />}
          <Typography
            fontSize={12}
            sx={{ color: textColor, fontWeight: 400, flex: 1 }}
          >
            Security deposit required to confirm booking
          </Typography>
        </Box>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        backgroundColor: "#E8F5E9",
        borderRadius: "12px",
        marginTop: "20px",
        padding: "14px",
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        ...containerStyle,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
        {showIcon && <ShieldIcon size={18} color={iconColor} />}
        <Typography
          fontSize={13}
          sx={{ color: textColor, fontWeight: 600 }}
        >
          Security Deposit Policy
        </Typography>
      </Box>

      <Typography
        fontSize={13}
        sx={{ color: textColor, fontWeight: 400, lineHeight: "20px" }}
      >
        Once you check in, the security hold will be released automatically.
      </Typography>

      <Box sx={{ display: "flex", alignItems: "flex-start", gap: "6px" }}>
        <InfoIcon size={18} color={iconColor} />
        <Typography
          fontSize={12}
          sx={{ color: textColor, fontWeight: 400, lineHeight: "18px", flex: 1 }}
        >
          <Typography component="span" sx={{ color: textColor, fontWeight: 600 }}>
            Terms:{" "}
          </Typography>
          If you inform us of a cancellation at least 24 hours before your
          booking, the hold will also be released. Otherwise, the full
          security amount will be charged.
        </Typography>
      </Box>
    </Box>
  );
};

export default SecurityDepositPolicy;